import type { I18nTranslation } from '@crehana/i18n';
import type { TSetTranslationKeys } from '@crehana/ts-types';

import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export type TKeys = TSetTranslationKeys<typeof es>;

const locales: I18nTranslation = { es, pt, en };

export default locales;
